module.exports = __webpack_public_path__ + "img/home-of-sports@2x.30be112d.jpg";